export default __webpack_public_path__ + "static/media/NP.b0b5321f.svg";